import type { SortOrder } from '@hivewatch/dark'
import { TableHeader, TableHeaderCell } from '@hivewatch/dark'

import type {
  RuleSortColumn,
  RuleSortOrder,
  RuleTableColumn,
} from '../types/rulesTable'

interface DarkRulesTableHeaderIProps {
  columns: RuleTableColumn[]
  sortColumn: RuleSortColumn | null
  sortOrder: RuleSortOrder | null
  onSortChange: (column: RuleSortColumn, order: RuleSortOrder) => void
}

const getSortOrder = (
  column: RuleSortColumn,
  sortColumn: RuleSortColumn | null,
  sortOrder: RuleSortOrder | null
): SortOrder => {
  if (sortColumn === column) return sortOrder ?? 'desc'
  if (sortColumn == null && column === 'createdAt') return 'default'
  return 'none'
}

const getNextSortOrder = (
  column: RuleSortColumn,
  sortColumn: RuleSortColumn | null,
  sortOrder: RuleSortOrder | null
): RuleSortOrder => {
  const currentOrder =
    sortColumn === column
      ? sortOrder
      : sortColumn == null && column === 'createdAt'
      ? 'desc'
      : null

  return currentOrder === 'asc' ? 'desc' : 'asc'
}

export const DarkRulesTableHeader = ({
  columns,
  sortColumn,
  sortOrder,
  onSortChange,
}: DarkRulesTableHeaderIProps) => (
  <TableHeader>
    {columns.map((column) => (
      <TableHeaderCell
        align={column.align}
        flexGrow={column.flexGrow}
        key={column.key}
        maxWidth={column.maxWidth}
        minWidth={column.minWidth}
        onSort={
          column.sortColumn
            ? () =>
                onSortChange(
                  column.sortColumn,
                  getNextSortOrder(column.sortColumn, sortColumn, sortOrder)
                )
            : undefined
        }
        sortOrder={
          column.sortColumn
            ? getSortOrder(column.sortColumn, sortColumn, sortOrder)
            : undefined
        }
        width={column.width}
      >
        {column.label}
      </TableHeaderCell>
    ))}
  </TableHeader>
)
